import visible from '../util/visible';
import $ from 'jquery';
import anime from 'animejs';



export default {
  init() {

    function isFloat(n){
      return Number(n) === n && n % 1 !== 0;
    }

    let hasrun = false;

    $(window).scroll(function(){

      if(visible('.stats') && !hasrun){

        hasrun = true;


        let stats = $('.value');
        for(let i=0; i < stats.length; i++){

          let number = parseFloat($(stats).eq(i).attr('data-amount'));
          let suffix = $(stats).eq(i).attr('data-amount').slice(-1);

          let round = 1;

          if(isFloat(number)) {

            round = 10
          }


          anime({
            targets: stats[i],
            innerHTML: [0, number + suffix],
            easing: 'easeOutQuad',
            duration: 2500,
            round: round,
          });


        }


      }
    });

  },
};
